import { find, map, isNil, filter, isEmpty } from "lodash/fp";
class Controller {
  constructor($injector, $mdDialog, City, $location, Lists) {
    "ngInject";
    this.$location = $location;
    this.Events = $injector.get("Events");
    this.CityHandler = $injector.get("CityHandler");
    this.$mdDialog = $mdDialog;
    this.City = City;
    this.Lists = Lists.all;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.selectedTab = 0;
    this.i18n = this.i18n || {};
    let currentCity = this.isDependCurrentCityOnly
      ? this.currentCity
      : this.currentCity || this.CityHandler.get();
    if (isNil(currentCity)) {
      // If no city chosen in the local storage the component will only support English
      currentCity = {};
    }
    if (!isNil(this.updateCityEvent)) {
      this.Events.on(this.updateCityEvent, this.updateLanguages.bind(this));
    }
    if (isNil(this.languages)) this.updateLanguages(currentCity);

    if (!this.fill) {
      this.fill = 90;
    }

    this.enableField = () => {
      this.i18n.isDisabled = false;
    };

    this.submitField = () => {
      const key = this.name || this.i18n.key;
      const value = this.languages.reduce((acc, { code }) => {
        acc[code] = this.i18n[code];
        return acc;
      }, {});
      const method = this.resourceMethod;
      const methodName = this.resourceMethodName;
      const result = { value, key, method, methodName };

      if (this.extraParams) result.extraParams = this.extraParams;

      this.Events.emit(this.eventName, result);
    };
  }

  $onChanges() {
    if (this.$location.absUrl().includes("promotions")) this.i18n = {};
    if (!isNil(this.currentCity)) {
      this.updateLanguages(this.currentCity);
    }
  }

  $onDestroy() {
    if (!isNil(this.updateCityEvent)) {
      this.Events.off(this.updateCityEvent, this.updateLanguages);
    }
  }

  updateLanguages(currentCity) {
    if (!isNil(currentCity.id)) currentCity._id = currentCity.id; // Fallback for objects with .id
    if (!isNil(currentCity) && !isNil(currentCity._id)) {
      if (Array.isArray(currentCity.languages)) {
        this.mapLanguages(currentCity);
      } else {
        this.City.get(currentCity._id).$promise.then(
          (response) => {
            this.mapLanguages(response);
          },
          (response) => this.Events.emit(this.errorNotificationEvent, response)
        );
      }
    }
  }

  mapLanguages(currentCity) {
    const mainLanguages = filter((lan) => lan !== "en", currentCity.languages);
    this.cityLanguages = ["en", ...mainLanguages];
    const mapLanguages = (languages) =>
      map((code) => {
        return find(
          (language) => code === language.code,
          this.Lists.availableCityLanguages
        );
      })(languages);

    this.languages = mapLanguages(this.cityLanguages);
  }

  isOneEmpty() {
    if (!isNil(this.languages)) {
      return this.languages.some(
        (lang) => isNil(this.i18n[lang.code]) || isEmpty(this.i18n[lang.code])
      );
    }
  }

  handleKeyDown(event) {
    const { key } = event;
    switch (key) {
      case "Tab":
        this.switchTab(event);
        break;
      case "Enter":
        if (!this.hideEdit && this.isRequired && !this.isOneEmpty()) {
          this.submitField();
        }
        break;
      // No Default
    }
  }

  switchTab(event) {
    const goBack = () => {
      event.preventDefault();
      this.selectedTab--;
    };

    const goForward = () => {
      event.preventDefault();
      this.selectedTab++;
    };
    if (event.shiftKey) {
      if (this.selectedTab > 0) {
        // Not First Language
        goBack();
      }
    } else if (this.selectedTab < this.languages.length - 1) {
      // Not Last Language
      goForward();
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/localeEditableField/localeEditableField.controller.js